import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";

import { Row } from "@rui/Stack";

export const ViewToggleButton = styled(Button)(({ theme }) => ({
  minWidth: "fit-content",
  fontFamily: theme.typography.fontFamilySecondary,
  marginLeft: "-8px",
  "&:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
    svg: { fontSize: "16px" },
  },
}));

export const NestedBanner = styled(Alert)(({ theme }) => ({
  width: "100%",
  border: "none",
  paddingLeft: 0,
  paddingRight: 0,
  backgroundColor: "transparent",
  color: "inherit",
  borderRadius: 0,
  "&:not(:first-of-type)": {
    borderTop: "1px solid",
    borderColor: theme.palette.transparent.black[12],
  },
  "& .MuiAlert-icon": {
    display: "none",
  },
}));

export const Preview = styled(Row)(({ onClick }) => ({
  flex: 1,
  width: "100%",
  minHeight: "28px",
  ...(onClick && {
    cursor: "pointer",
  }),
}));
